import { createContext, useContext, useEffect, useState } from "react";
import API from "../api";
import { Model } from "../types/scenes";
import { useAuth } from "./Authentication";

type ContextProps = {
  models: Model[];
}
const AppConfigContext = createContext<ContextProps | null>(null);

type Props = {
  children: React.ReactNode;
}

export function AppConfigProvider({ children }: Props) {
  const { isAuthenticated } = useAuth();
  const [ models, setModels ] = useState<Model[]>([]);

  useEffect(() => {
    if (models.length > 0 || !isAuthenticated) {
      return;
    }

    // eslint-disable-next-line no-console
    API.getModels().then(res => setModels(res.results)).catch(console.log);
  }, [isAuthenticated, models.length]);

  const contextValue = {
    models
  };

  return (
    <AppConfigContext.Provider value={contextValue}>
      {children}
    </AppConfigContext.Provider>
  );
}

export function useModels() {
  const { models } = useContext(AppConfigContext)  as ContextProps || {};

  return { models };
}

export function useModel(modelId?: number) {
  const { models } = useContext(AppConfigContext)  as ContextProps || {};
  if (!modelId) return;
  return models.find(({ id }) => id === modelId);
}
